import { z } from 'zod';
import { OrganizationSchema, PrivacyModeSchema } from '../../entities/organization/organization.schema';
import { ErrorCode } from '../../shared/error-codes';
import { SupportedLanguageSchema } from '../../shared/language.schema';
import { CapacityPrioritySchema } from '../../shared/capacity-priority';
/**
 * Update Organization Request Schema
 * PATCH /api/v2/organization
 */ export const UpdateOrganizationRequestSchema = z.object({
    settings: z.object({
        defaultLanguage: SupportedLanguageSchema.optional(),
        enableRecordingSurvey: z.boolean().optional(),
        enableFrequencySurvey: z.boolean().optional(),
        enableDurationSurvey: z.boolean().optional(),
        enableVariantCheck: z.boolean().optional(),
        standardRecordingTime: z.number().min(1, ErrorCode.FIELD_REQUIRED).optional(),
        reviewTimeframe: z.number().min(1, ErrorCode.FIELD_REQUIRED).optional(),
        internalBillingRate: z.number().positive(ErrorCode.FIELD_INVALID).optional(),
        ai: z.object({
            enableBliksy: z.boolean().optional(),
            enableStepNameGeneration: z.boolean().optional()
        }).optional(),
        privacyMode: PrivacyModeSchema.optional(),
        capacityPriority: CapacityPrioritySchema.optional()
    }).optional()
});
/**
 * Update Organization Response Schema
 * PUT /api/v2/organization
 */ export const UpdateOrganizationResponseSchema = z.object({
    data: OrganizationSchema
});

//# sourceMappingURL=update-organization.schema.js.map